import { render } from "./SolicitarRoteiro.vue?vue&type=template&id=2deae9b3&lang=pug"
import script from "./SolicitarRoteiro.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitarRoteiro.vue?vue&type=script&setup=true&lang=js"

import "./SolicitarRoteiro.vue?vue&type=style&index=0&id=2deae9b3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__